<mdb-navbar SideClass="navbar navbar-expand-lg navbar-light white">
  <mdb-navbar-brand>
    <a class="navbar-brand" href="#" routerLink="/{{identifier}}">
      <img src="{{theme.logoUri}}" class="logo">
    </a>
  </mdb-navbar-brand>
</mdb-navbar>
